import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 bg-white/90 rounded-xl"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 bg-white/90 rounded-xl"
}
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-blue-700"
}
const _hoisted_4 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_5 = { class: "p-5 border-b border-gray-200 flex justify-between gap-4" }
const _hoisted_6 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_7 = {
  key: 0,
  class: "block mt-1 text-xs text-blue-700"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "px-5 py-4 border-b border-gray-200 space-y-3" }
const _hoisted_10 = { class: "flex flex-wrap gap-2 max-h-24 overflow-y-auto" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_12 = { class: "space-y-1" }
const _hoisted_13 = { class: "p-5 grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_14 = { class: "md:col-span-2 space-y-3" }
const _hoisted_15 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3" }
const _hoisted_16 = { class: "md:col-span-2" }
const _hoisted_17 = { class: "md:col-span-2" }
const _hoisted_18 = {
  key: 0,
  class: "mt-2 p-3 bg-blue-50 border-l-4 border-blue-500 rounded-r"
}
const _hoisted_19 = {
  key: 0,
  class: "text-sm text-blue-700"
}
const _hoisted_20 = {
  key: 1,
  class: "text-sm text-red-600"
}
const _hoisted_21 = {
  key: 2,
  class: "text-xs text-blue-600"
}
const _hoisted_22 = { class: "p-5 border-t border-gray-200 space-y-3" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm text-red-600"
}
const _hoisted_24 = { class: "flex justify-end gap-2" }

import { inject } from "vue";
import BaseInput from "@/components/forms/BaseInput.vue";
import CategoryTreeAutocomplete from "@/components/forms/CategoryTreeAutocomplete.vue";
import CouleursSelector from "@/components/mel/CouleursSelector.vue";
import CompositionForm from "@/components/mel/CompositionForm.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import {
  useShopifyMelBulkSheet,
  type ShopifyMelBulkSheetContext,
} from "@/composables/useShopifyMelBulkSheet";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopifyMelBulkSheet',
  setup(__props, { expose: __expose }) {

const context = inject<ShopifyMelBulkSheetContext>("shopifyMelBulkContext");
if (!context) {
  throw new Error("shopifyMelBulkContext is required");
}

const {
  SHOPIFY_BULK_BATCH_SIZE,
  showBulkComplete,
  bulkModalLoading,
  savingBulkComplete,
  bulkProgressLabel,
  bulkSelectionProducts,
  bulkBatchCount,
  bulkMissingSummary,
  bulkForm,
  bulkSelectedCategoryLevel1,
  bulkSelectedCategoryLevel2,
  bulkSelectedCategoryLevel3,
  bulkSelectedCompositions,
  bulkCompositionType,
  bulkCompositionLocations,
  bulkShoeCompositions,
  bulkCompositionAutocompleteOptions,
  bulkShowCompositionDropdown,
  bulkIsLoadingCompositionAutocomplete,
  bulkSelectedColors,
  bulkFormValidationMessage,
  canSaveBulkForm,
  bulkMelangeesPackMismatchMessage,
  brandOptions,
  collectionOptions,
  provenanceOptions,
  sizeRangeOptions,
  categoryLevel1Options,
  bulkCategoryLevel2Options,
  bulkCategoryLevel3Options,
  bulkPackOptions,
  bulkSelectedSizeNames,
  soldByOptions,
  categoriesTree,
  officialColors,
  openBulkComplete,
  closeBulkComplete,
  saveBulkComplete,
  onBulkCategoryPathSelect,
  onBulkCategoryLevel1Change,
  onBulkCategoryLevel2Change,
  onBulkCategoryLevel3Change,
  onBulkCategoryPathClear,
  handleBulkCompositionInput,
  selectBulkComposition,
  hideBulkCompositionDropdown,
} = useShopifyMelBulkSheet(context);

__expose({ openBulkComplete });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(showBulkComplete))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-[9997] flex items-center justify-center p-3 overflow-hidden overscroll-none",
          onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            class: "absolute inset-0 bg-black/50",
            "aria-label": "Fermer",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeBulkComplete) && _unref(closeBulkComplete)(...args)), ["stop"]))
          }),
          _createElementVNode("form", {
            class: "relative bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto",
            onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"])),
            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_unref(bulkModalLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[18] || (_cache[18] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl text-blue-600" }, null, -1),
                  _createElementVNode("p", { class: "text-sm text-gray-600" }, "Chargement du formulaire…", -1)
                ])))
              : (_unref(savingBulkComplete))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl text-blue-600" }, null, -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-sm font-medium text-black" }, " Application des modifications… ", -1)),
                    (_unref(bulkProgressLabel))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(bulkProgressLabel)), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_4, " Mise à jour de " + _toDisplayString(_unref(bulkSelectionProducts).length) + " fiche(s), merci de patienter. ", 1))
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "text-lg font-semibold text-black" }, " Compléter la sélection ", -1)),
                _createElementVNode("p", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(bulkSelectionProducts).length) + " produit(s) sélectionné(s). Seuls les champs renseignés ci-dessous seront appliqués. ", 1),
                  (_unref(bulkBatchCount) > 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Traitement automatique par lots de " + _toDisplayString(_unref(SHOPIFY_BULK_BATCH_SIZE)) + " fiches (" + _toDisplayString(_unref(bulkBatchCount)) + " lots). ", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "text-gray-500",
                disabled: _unref(bulkModalLoading) || _unref(savingBulkComplete),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(closeBulkComplete) && _unref(closeBulkComplete)(...args)))
              }, _cache[22] || (_cache[22] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]), 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-sm font-semibold text-black" }, "Produits concernés", -1)),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bulkSelectionProducts), (product) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `bulk-ref-${product.id}`,
                    class: "px-2 py-1 rounded-full text-xs bg-gray-100 text-gray-700"
                  }, _toDisplayString(product.reference || product.id), 1))
                }), 128))
              ]),
              (_unref(bulkMissingSummary).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "font-medium text-black mb-1" }, "Champs encore manquants", -1)),
                    _createElementVNode("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bulkMissingSummary), ([field, count]) => {
                        return (_openBlock(), _createElementBlock("li", { key: field }, _toDisplayString(field) + " : " + _toDisplayString(count) + "/" + _toDisplayString(_unref(bulkSelectionProducts).length), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-sm font-semibold text-black" }, "Catégorie eFashion", -1)),
                _createVNode(CategoryTreeAutocomplete, {
                  tree: _unref(categoriesTree),
                  "cat-id": _unref(bulkSelectedCategoryLevel1),
                  "sous-id": _unref(bulkSelectedCategoryLevel2),
                  "sous-sous-id": _unref(bulkSelectedCategoryLevel3),
                  label: "Recherche rapide catégorie",
                  placeholder: "Rechercher une catégorie (ex. robe, jean…)",
                  onSelect: _unref(onBulkCategoryPathSelect),
                  onClear: _unref(onBulkCategoryPathClear)
                }, null, 8, ["tree", "cat-id", "sous-id", "sous-sous-id", "onSelect", "onClear"]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(BaseInput, {
                    modelValue: _unref(bulkSelectedCategoryLevel1),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(bulkSelectedCategoryLevel1) ? (bulkSelectedCategoryLevel1).value = $event : null)),
                    type: "select",
                    "open-on-focus": "",
                    label: "Catégorie",
                    options: _unref(categoryLevel1Options),
                    placeholder: "Ne pas modifier",
                    onChange: _unref(onBulkCategoryLevel1Change)
                  }, null, 8, ["modelValue", "options", "onChange"]),
                  _createVNode(BaseInput, {
                    modelValue: _unref(bulkSelectedCategoryLevel2),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(bulkSelectedCategoryLevel2) ? (bulkSelectedCategoryLevel2).value = $event : null)),
                    type: "select",
                    "open-on-focus": "",
                    label: "Sous-catégorie",
                    options: _unref(bulkCategoryLevel2Options),
                    placeholder: "Ne pas modifier",
                    disabled: !_unref(bulkSelectedCategoryLevel1),
                    onChange: _unref(onBulkCategoryLevel2Change)
                  }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
                  _createVNode(BaseInput, {
                    modelValue: _unref(bulkSelectedCategoryLevel3),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(bulkSelectedCategoryLevel3) ? (bulkSelectedCategoryLevel3).value = $event : null)),
                    type: "select",
                    "open-on-focus": "",
                    label: "Sous-sous-catégorie",
                    options: _unref(bulkCategoryLevel3Options),
                    placeholder: "Ne pas modifier",
                    disabled: 
                  !_unref(bulkSelectedCategoryLevel2) ||
                  !_unref(bulkCategoryLevel3Options).length
                ,
                    onChange: _unref(onBulkCategoryLevel3Change)
                  }, null, 8, ["modelValue", "options", "disabled", "onChange"])
                ])
              ]),
              _createVNode(BaseInput, {
                modelValue: _unref(bulkForm).brandId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bulkForm).brandId) = $event)),
                type: "select",
                "open-on-focus": "",
                label: "Marque",
                options: _unref(brandOptions),
                placeholder: "Ne pas modifier"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(BaseInput, {
                modelValue: _unref(bulkForm).collectionId,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bulkForm).collectionId) = $event)),
                type: "select",
                "open-on-focus": "",
                label: "Collection",
                options: _unref(collectionOptions),
                placeholder: "Ne pas modifier"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(BaseInput, {
                modelValue: _unref(bulkForm).provenanceId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bulkForm).provenanceId) = $event)),
                type: "select",
                "open-on-focus": "",
                label: "Provenance",
                options: _unref(provenanceOptions),
                placeholder: "Ne pas modifier"
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", null, [
                _createVNode(BaseInput, {
                  modelValue: _unref(bulkForm).price,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bulkForm).price) = $event)),
                  type: "number",
                  label: "Prix HT",
                  step: "0.01",
                  min: "0",
                  placeholder: "Ne pas modifier"
                }, null, 8, ["modelValue"]),
                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-xs text-amber-700 mt-1" }, " Les prix Shopify sont souvent des prix B2C. Indiquez le prix grossiste HT eFashion si besoin. ", -1))
              ]),
              _createElementVNode("div", null, [
                _createVNode(BaseInput, {
                  modelValue: _unref(bulkForm).weight,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bulkForm).weight) = $event)),
                  type: "number",
                  label: "Poids unitaire (kg)",
                  step: "0.001",
                  min: "0.001",
                  max: 5,
                  placeholder: "Ne pas modifier"
                }, null, 8, ["modelValue"]),
                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-xs text-red-600 mt-0.5" }, " Merci de bien vouloir augmenter légèrement le poids pour prendre en compte les cintres, cartons ou surplus d'emballage. Maximum 5 kg. ", -1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(CompositionForm, {
                  modelValue: _unref(bulkSelectedCompositions),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(bulkSelectedCompositions) ? (bulkSelectedCompositions).value = $event : null)),
                  "composition-type": _unref(bulkCompositionType),
                  localisations: _unref(bulkCompositionLocations),
                  "compositions-list": _unref(bulkShoeCompositions),
                  "autocomplete-options": _unref(bulkCompositionAutocompleteOptions),
                  "show-autocomplete-dropdown": _unref(bulkShowCompositionDropdown),
                  "is-loading-autocomplete": _unref(bulkIsLoadingCompositionAutocomplete),
                  onCompositionInput: _unref(handleBulkCompositionInput),
                  onHideDropdown: _unref(hideBulkCompositionDropdown),
                  onSelectAutocomplete: _unref(selectBulkComposition)
                }, null, 8, ["modelValue", "composition-type", "localisations", "compositions-list", "autocomplete-options", "show-autocomplete-dropdown", "is-loading-autocomplete", "onCompositionInput", "onHideDropdown", "onSelectAutocomplete"])
              ]),
              _createVNode(BaseInput, {
                modelValue: _unref(bulkForm).soldBy,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bulkForm).soldBy) = $event)),
                type: "select",
                "open-on-focus": "",
                label: "Vendu par",
                options: _unref(soldByOptions),
                placeholder: "Ne pas modifier"
              }, null, 8, ["modelValue", "options"]),
              _cache[29] || (_cache[29] = _createElementVNode("p", { class: "md:col-span-2 -mt-2 text-xs text-gray-500" }, " À choisir manuellement : Shopify ne fournit pas le mode de vente eFashion. ", -1)),
              _createVNode(BaseInput, {
                modelValue: _unref(bulkForm).sizeRangeId,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(bulkForm).sizeRangeId) = $event)),
                type: "select",
                "open-on-focus": "",
                label: "Taille du paquet",
                options: _unref(sizeRangeOptions),
                placeholder: "Ne pas modifier"
              }, null, 8, ["modelValue", "options"]),
              (_unref(bulkForm).soldBy && _unref(bulkForm).soldBy !== 'tailles')
                ? (_openBlock(), _createBlock(BaseInput, {
                    key: 0,
                    modelValue: _unref(bulkForm).packId,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(bulkForm).packId) = $event)),
                    type: "select",
                    "open-on-focus": "",
                    label: "Quantité du paquet",
                    options: _unref(bulkPackOptions),
                    placeholder: "Ne pas modifier"
                  }, null, 8, ["modelValue", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(CouleursSelector, {
                  modelValue: _unref(bulkSelectedColors),
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(bulkSelectedColors) ? (bulkSelectedColors).value = $event : null)),
                  "couleurs-list": _unref(officialColors),
                  "tailles-list": 
                _unref(bulkForm).soldBy === 'melangees'
                  ? _unref(bulkSelectedSizeNames)
                  : undefined
              ,
                  "force-validate": Boolean(_unref(bulkFormValidationMessage))
                }, null, 8, ["modelValue", "couleurs-list", "tailles-list", "force-validate"]),
                _cache[28] || (_cache[28] = _createElementVNode("p", { class: "mt-2 text-xs text-gray-500" }, " Optionnel : laissez vide pour ne pas modifier les couleurs des produits sélectionnés. ", -1)),
                (_unref(bulkForm).soldBy === 'melangees')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (!_unref(bulkForm).sizeRangeId)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Sélectionnez la déclinaison pour saisir les quantités par taille. "))
                        : (_unref(bulkMelangeesPackMismatchMessage))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(bulkMelangeesPackMismatchMessage)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_21, " Pour chaque couleur, indiquez la composition du paquet par taille (obligatoire, au moins une quantité > 0 par couleur). La somme doit correspondre au pack sélectionné. "))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_unref(bulkFormValidationMessage))
                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(bulkFormValidationMessage)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(ActionButton, {
                  label: "Annuler",
                  variant: "secondary",
                  type: "button",
                  disabled: _unref(bulkModalLoading) || _unref(savingBulkComplete),
                  onClick: _unref(closeBulkComplete)
                }, null, 8, ["disabled", "onClick"]),
                _createVNode(ActionButton, {
                  label: "Appliquer à la sélection",
                  variant: "primary",
                  type: "button",
                  loading: _unref(savingBulkComplete),
                  disabled: 
                _unref(bulkModalLoading) || _unref(savingBulkComplete) || !_unref(canSaveBulkForm)
              ,
                  onClick: _unref(saveBulkComplete)
                }, null, 8, ["loading", "disabled", "onClick"])
              ])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})